/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Total/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Total({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/Treatment/Total"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let payersTreatmentTotalToBePaidValueData = fromData.useDataFormat({ viewPath,
context: 'payers',
path: 'treatment.total_to_be_paid',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<div
  data-testid="Total.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-5PPze': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Total to be paid"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="large"
 data="payers.treatment.total_to_be_paid"
 format="/Data/format.js numberMoney"
 text={payersTreatmentTotalToBePaidValueData}
/>
</div>
{children}
</React.Fragment>)
}